import { StatusEvolutionContainer } from './styles';
import { useI18n } from '../../shared/i18n';

interface IItemStatusProps {
  marginLeft?: boolean;
  type?: number | undefined;
}

export const ItemStatus: React.FC<IItemStatusProps> = ({
  marginLeft,
  type,
}) => {
  const { t } = useI18n();
  interface IItemStatus {
    name: string;
    color: string;
  }
  let obj: IItemStatus | null = null;
  switch (type) {
    case 1:
      obj = { name: t('statusItemTreatment.inProgress'), color: '#1677ff' };
      break;
    case 2:
      obj = { name: t('statusItemTreatment.completed'), color: '#32cf5c' };
      break;
    default:
      obj = { name: t('statusItemTreatment.pending'), color: '#8a8a8a' };
      break;
  }

  return (
    <StatusEvolutionContainer color={obj.color} marginLeft={marginLeft}>
      {obj.name}
    </StatusEvolutionContainer>
  );
};
